import { z } from "zod";
import { OrderDocumentSourceTypeSchema } from "~/shared/documents/order-document-source";

export const CarrierInstructionCostReferenceSchema = z.object({
  sourceType: OrderDocumentSourceTypeSchema,
  costId: z
    .string()
    .uuid()
    .transform(id => id.toLowerCase()),
});

export type CarrierInstructionCostReference = z.infer<typeof CarrierInstructionCostReferenceSchema>;

/** Display metadata only; generation reloads the selected source costs. */
export type CarrierInstructionCostCandidate = CarrierInstructionCostReference & {
  orderId: string;
  orderNo: string;
  description: string;
  supplierName: string;
  accountName: string;
  amountCents: string;
  currencyCode: string;
  isFreight: boolean;
};

export type CarrierInstructionRateRow = {
  description: string;
  amount: string;
  currency: string;
};

export const carrierInstructionCostKey = (reference: CarrierInstructionCostReference): string =>
  `${reference.sourceType}:${reference.costId.toLowerCase()}`;

/** OrderCost uses bigint cents; never round it through a JavaScript number. */
export const formatCarrierInstructionCostAmount = (amountCents: string): string => {
  const cents = BigInt(amountCents);
  const magnitude = cents < 0n ? -cents : cents;
  return `${cents < 0n ? "-" : ""}${magnitude / 100n}.${(magnitude % 100n).toString().padStart(2, "0")}`;
};
